import Masonry from 'masonry-layout';

export default class ArchivePage {
    constructor() {
        // console.info('ArchivePage.constructor()');

        this.state = {
            currentParentFilter: null,
            currentChildFilter: null,
        };

        this.grid = document.querySelector('.js-box-grid');
        this.msnry = new Masonry(this.grid, {
            itemSelector: '.masonry-brick',
            columnWidth: '.grid-sizer',
            gutter: 20,
            isFitWidth: true,
            isResizable: true,
            transitionDuration: '0.2s',
            percentPosition: true,
            horizontalOrder: true,
            isAnimated: true,
            animationOptions: {
                duration: 250,
                easing: 'linear',
                queue: false,
            },
        });

        this.initMasonry();
        this.initListeners();

        // handle category in url /products/category/<catslug>/
        const urlParts = window.location.href.split('/');
        const slug = urlParts.pop() || urlParts.pop(); // handle final slash
        $(`.js-filters-main .list__item.${slug} .js-filter-toggle`).click();
    }

    initMasonry() {
        this.msnry.on('layoutComplete', () => {
            this.grid.classList.add('load');
        });

        this.msnry.layout();
    }

    initListeners() {
        // console.info('ArchivePage.initListeners()');

        $('.js-filters-main .js-filter-toggle').on('click', (e) => {
            // console.info('Main Filter Click!');

            e.preventDefault();

            $('.js-filters-main').find('.js-filter-toggle').removeClass('active');
            $(e.currentTarget).addClass('active');

            this.state.currentParentFilter = $(e.currentTarget).data('id') ? $(e.currentTarget).data('id') : null;

            if ($('.filters--sub').length) {
                this.updateSubFilters();
            } else {
                this.render();
            }
        });

        $('.js-filters-sub .js-filter-toggle').on('click', (e) => {
            // console.info('Sub Filter Click!');

            e.preventDefault();

            $('.js-filters-sub').find('.js-filter-toggle').removeClass('active');
            $(e.currentTarget).addClass('active');

            this.state.currentChildFilter = $(e.currentTarget).data('id') ? $(e.currentTarget).data('id') : null;

            this.render();
        });
    }

    updateSubFilters() {
        // console.info('ArchivePage.updateSubFilters()');

        if (this.state.currentParentFilter !== null) {
            const cat = this.state.currentParentFilter;

            $('.js-filters-sub').closest('.filters').show();
            $('.js-filters-sub .list__item:first-child .js-filter-toggle').click();

            $('.js-filters-sub .list__item').each(function () {
                const parent = $(this).data('parent') ? $(this).data('parent') : null;

                if (parent !== null && parent !== cat) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        } else {
            $('.js-filters-sub .list__item:first-child .js-filter-toggle').click();

            $('.js-filters-sub').closest('.filters').hide();
        }
    }

    render() {
        // console.info('ArchivePage.render()');

        if (this.state.currentParentFilter === null) {
            $('.js-box-grid .list__item')
                .addClass('masonry-brick')
                .fadeIn(() => {
                    this.msnry.layout();
                });
        } else if (this.state.currentChildFilter === null) {
            $('.js-box-grid .list__item').each((index, element) => {
                if ($(element).hasClass(this.state.currentParentFilter)) {
                    $(element)
                        .addClass('masonry-brick')
                        .fadeIn(() => {
                            this.msnry.layout();
                        });
                } else {
                    $(element)
                        .removeClass('masonry-brick')
                        .fadeOut(() => {
                            this.msnry.layout();
                        });
                }
            });
        } else if (this.state.currentParentFilter && this.state.currentChildFilter) {
            $('.js-box-grid .list__item').each((index, element) => {
                if (
                    $(element).hasClass(this.state.currentParentFilter) &&
                    $(element).hasClass(this.state.currentChildFilter)
                ) {
                    $(element)
                        .addClass('masonry-brick')
                        .fadeIn(() => {
                            this.msnry.layout();
                        });
                } else {
                    $(element)
                        .removeClass('masonry-brick')
                        .fadeOut(() => {
                            this.msnry.layout();
                        });
                }
            });
        }
    }
}
